<template>
  <v-container
    id="kpi-list"
    fluid
    tag="section"
  >
    <filter-form :filter-form="filterForm" />
    <kpi-list-table
      :kpis="kpis"
    />
    <common-no-result
      v-if="!loading && totalItem === 0"
    />
    <v-row class="mt-4">
      <v-col
        cols="12"
        sm="6"
      />
      <v-col
        cols="12"
        sm="6"
      >
        <v-pagination
          v-if="totalItem > limit"
          v-model="currentPage"
          :length="getTotalItem(totalItem)"
          class="justify-sm-end"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import FilterForm from './components/FilterForm.vue'
  import KpiListTable from './components/KpiTable'
  import RepositoryFactory from '../../repositories/RepositoryFactory'
  import { formatDate } from '../../helpers/utils'
  const KpiRepository = RepositoryFactory.get('kpi')
  export default {
    components: { FilterForm, KpiListTable },
    data () {
      return {
        filterForm: {},
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        kpis: [],
        loading: false,
      }
    },
    watch: {
      currentPage: {
        handler () {
          this.getKpiList()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.getKpiList()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    created () {
      this.getKpiList()
      Bus.$on('kpi-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.currentPage = 1
        this.getKpiList()
      })
      Bus.$on('kpi-list-reload', () => {
        this.getKpiList()
      })
    },
    beforeDestroy () {
      Bus.$off('kpi-list-filter')
    },
    methods: {
      async getKpiList () {
        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          keyword: this.filterForm.keyword
        }
        // const loader = this.$loading.show()
        this.appLoadingData(true)
        const response = await KpiRepository.list(params)
        // loader.hide()
        this.appLoadingData(false)
        if (response.success) {
          this.kpis = _.get(response, 'data', []).map((kpi) => {
            return {
              ...kpi,
              startAt: formatDate(kpi.startAt),
              endAt: formatDate(kpi.endAt),
              departmentIds: _.get(kpi, 'departments', []).map(d => d.id),
            }
          })
          this.totalItem = response.totalItem
        }
      },
    },
  }
</script>
